import {Injectable, SecurityContext} from '@angular/core';
import {Group} from 'konva/lib/Group';
import {IAdComponentData, IGraphNode} from '../models/graph-kn.model-interfaces';
import {Rect, RectConfig} from 'konva/lib/shapes/Rect';
import {Text} from 'konva/lib/shapes/Text';
import {GraphKnDataService} from './graph-kn.data.service';
import {INodeAvatarStyleConfig, INodeStyleConfing} from '../models/graph-kn.cm.nodes-model-const';
import {TranslateService} from '@ngx-translate/core';
import {basePrimary, baseSecondary} from '../styles/graph-colors';
import { IMemberWithRole, MemberModel } from '../../../models/user.model';
import { crc1 } from 'crc';
import { Vector2d } from 'konva/lib/types';
import { GraphKnUIElementsService } from './graph-kn.ui.elements.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { filter } from 'rxjs';
import { BUSINESS_PROCESS_LAYER_ID } from '../models/graph-kn.cm-api-models';
import { Image } from 'konva/lib/shapes/Image';
import { HelpersService } from '../../../services/helpers.service';
import { ContractAvatarsService } from '../../contracts/services/contract-avatar.service';
import { NodesStylingMap } from '../styles/nodes-styles/graph-node--map-styles-root';
import { GraphKnHelperService } from './graph-kn.helpers.service';
const colorForGenAvatars = [
  ['#284073', '#5c7aa9'], ['#284073', '#2563EB'],
  ['#284073', '#5c7aa9'], ['#284073', '#2563EB'],
  ['#284073', '#5c7aa9'], ['#284073', '#2563EB'],
  ['#284073', '#5c7aa9'], ['#284073', '#2563EB'],
  ['#284073', '#5c7aa9'], ['#284073', '#2563EB'],
  ['#284073', ' #5c7aa9'], ['#284073', '#2563EB'],
];
interface IGradient {
	startcolor:string,
	endColor:string
}
interface IAvatarGroupData {
	group:Group,
	rect:Rect,
	text:Text
}
interface IGuidRole {
	guid:string,
	role:string,
}
@Injectable({
    providedIn: 'root'
})
export class GraphKnUIAvatarService {
    constructor(
		private knDataService: GraphKnDataService,
		private translateService: TranslateService,
		private knUIElementsService:GraphKnUIElementsService,
		private sanitizer:DomSanitizer,
		private helpersService:HelpersService,
		private graphHelpersService:GraphKnHelperService,
		private contractAvatarsService:ContractAvatarsService
    ) {
		this.setAvatarPanelSubscriptions()
    }
	setAvatarPanelSubscriptions() {
		this.knDataService.BsAvatarData.asObservable()
		.pipe(filter(avatars=>avatars.size>0))
		.subscribe(avatars=>this.handleImgAvatars(avatars))
	}
	createAvatarsPanel(nodeGroup: Group, node: IGraphNode, rectModel:RectConfig) {
		let usersData = this.prepareUserList(node)
        
		let usersGuids = usersData.map(el=>el.guid)
		if (usersGuids.length === 0) {
            return
		}
		this.knDataService.BsUsersData.asObservable()
		.pipe()
		.subscribe(members=>{
            let cssNodeStyles = NodesStylingMap.get(node.nodeType) as INodeStyleConfing
			let cssSettingsStatus = cssNodeStyles.statusPanel 
			let cssSettingsAvatars = cssNodeStyles.avatarPanel
			let baseX = (cssSettingsStatus.offsetX + cssSettingsStatus.width + cssSettingsAvatars.gapPanel) * (rectModel.width!) ;
			let baseY = cssSettingsAvatars.offsetY * (rectModel.height!);
			let avatarPanelGroup = new Group({
				x: baseX ,
				y: baseY,
			})
			let rect= new Rect({
			  cornerRadius:2,
			  strokeWidth:1,
              //stroke:'green',
			  height:30,
			  width:cssSettingsAvatars.width *  (rectModel.width!)
			})
			avatarPanelGroup.add(rect)
			nodeGroup.add(avatarPanelGroup);
			let membersArr = (members as MemberModel[]);
			if (membersArr.length>0 && usersGuids.length>0) {
				let members = membersArr.filter(el=>usersGuids.includes(el.guid))
				let panelWidth = cssSettingsAvatars.width * (rectModel.width!)
				membersArr?.length>0? this.createGenericAvatars(members, avatarPanelGroup, panelWidth,usersData,cssNodeStyles) : null;
				let usersWithCachedImgs : Map<string,{img:SafeUrl}> = new Map([])
				usersGuids.forEach(el=>{
					let imgData = this.contractAvatarsService.contractAvatarMap?.get(el)
					imgData? usersWithCachedImgs.set(el,imgData): null
				})
				usersWithCachedImgs.size>0? this.handleImgAvatars(usersWithCachedImgs ) : null
			}
            if (membersArr.length>0 && usersGuids.length>0 && node.bp_status_data) {
                node.bp_status_data.members = membersArr
            }
		})
    }
	createGenericAvatars(users:MemberModel[],avatarPanelGroup:Group, panelWidth:number,userData:IGuidRole[],cssNodeStyles:INodeStyleConfing) {
		let cssSettingsAvatars = cssNodeStyles.avatarPanel
		let excessiveAvatarWidth = panelWidth - cssSettingsAvatars.avatarHeight * (users.length) - cssSettingsAvatars.gapAvatar * (users.length-1)
		excessiveAvatarWidth > 0? excessiveAvatarWidth = 0 : null
		let addPlusAvatarCount = Math.ceil(-1 * excessiveAvatarWidth / (cssSettingsAvatars.avatarHeight + cssSettingsAvatars.gapAvatar))
		let plusAvatar = 0
		addPlusAvatarCount > 0? plusAvatar = 1 : null;
		let leftOut = addPlusAvatarCount <= 0? 1 : addPlusAvatarCount + 1
		
		let startIndex = users.length - leftOut
		for (let index = startIndex; index >= 0 ; index--) {
			let user = users[index];
			let fName = user.firstname ? user.firstname.charAt(0).toUpperCase() : '';
			let lName = user.lastname ? user.lastname.charAt(0).toUpperCase() : '';
			let initials = fName + lName;
			let groupPos:Vector2d = {
				x: panelWidth - cssSettingsAvatars.avatarHeight * (index + plusAvatar +1) - cssSettingsAvatars.gapAvatar * (index+plusAvatar) ,
				y:0
			}
			let gradient:IGradient = this.prepareGenericAvatarBackGround(user.email)
			let avatarGroupData = this.createGenericAvatarGroup(groupPos,cssSettingsAvatars,initials,user.guid,gradient)

			avatarGroupData.text.on('click', (event) => {
				event.cancelBubble = true
				this.helpersService.openProfileByGuid(user.guid)
			})

			let role = userData.find(el=>el.guid === user.guid)?.role
			role = this.translateService.instant('TASKS.TEXT.TASK_ROLES.' + role) + ': '
			let avatarToolTipText = role + user.lastname + ' ' + user.firstname;
			let cssTooltip = cssSettingsAvatars.tooltip
			this.createAvatarsToolTip(avatarGroupData,avatarToolTipText,cssTooltip.fontSize,cssTooltip.backGround)
			avatarPanelGroup.add(avatarGroupData.group)
		}
		if (addPlusAvatarCount > 0) {
			let groupPos:Vector2d = {
				x:panelWidth - cssSettingsAvatars.avatarHeight - 2,
				y:0
			}
            let usersWithRoles:IMemberWithRole[] = users.map(user=>{
                return {
                    member:user,
                    role:userData.find(el=>el.guid === user.guid)?.role!
                }
            })
            this.addPlusAvatar(addPlusAvatarCount,avatarPanelGroup,groupPos,cssSettingsAvatars,usersWithRoles)
		} 
	}
	addPlusAvatar(
        addPlusAvatarCount:number, avatarPanelGroup:Group,
        groupPos:Vector2d,cssSettingsAvatars:INodeAvatarStyleConfig,users:IMemberWithRole[]
    ):IAvatarGroupData {
		let gradient:IGradient = {
			startcolor: baseSecondary,
			endColor:baseSecondary
		}
        let tooltip = this.translateService.instant('GRAPH.BUTTONS.TOOLTIPS.FULL_MEMBERS_LIST')
        let plusAvatarGroup = 
        this.createGenericAvatarGroup(groupPos,cssSettingsAvatars,'+' + addPlusAvatarCount,'Plus_Avatar', gradient,basePrimary)
        this.createAvatarsToolTip(plusAvatarGroup,tooltip,cssSettingsAvatars.tooltip.fontSize,cssSettingsAvatars.tooltip.backGround)

        
        plusAvatarGroup.text.on('click', (event) => {
            let stageRect = this.knDataService.graphStage.container().getBoundingClientRect()
            event.cancelBubble = true;
            let userListData:IAdComponentData = {
                left:plusAvatarGroup.text.getAbsolutePosition().x + stageRect.left - 100,
                top:plusAvatarGroup.text.getAbsolutePosition().y + plusAvatarGroup.text.height() + stageRect.top + 20,
                visibility:'visible',
                data:users
            }
            this.knDataService.subUserListOpen.next(userListData)
        })
        avatarPanelGroup.add(plusAvatarGroup.group)
        return plusAvatarGroup
	}
	createImgAvatar(){

	}
	createGenericAvatarGroup(
		groupPos:Vector2d,
		cssSettingsAvatars: INodeAvatarStyleConfig,
		textData:string,
		userGuid:string,
		gradient?:IGradient,
		textColor?:string
	): IAvatarGroupData
	{
		let avatarGroup = new Group ({
			id:'avatarGroup_' + userGuid,
			x:groupPos.x,
			y:groupPos.y,
            css:cssSettingsAvatars
		})
		let avatarRect = new Rect({
			id:'avatarRect',
			width:cssSettingsAvatars.avatarHeight,
			height:cssSettingsAvatars.avatarHeight,
			stroke:cssSettingsAvatars.borderColor,
			strokeWidth:cssSettingsAvatars.borderSize,

			cornerRadius:cssSettingsAvatars.avatarRadius,
			perfectDrawEnabled:true 
		})
		if (gradient) {
			avatarRect.fillLinearGradientStartPoint({ x: 0, y: 0 })
			avatarRect.fillLinearGradientEndPoint({ x:cssSettingsAvatars.avatarHeight , y: cssSettingsAvatars.avatarHeight })
			avatarRect.fillLinearGradientColorStops([0, gradient.startcolor, 1, gradient.endColor])
		}
		let avatarText = new Text({
			x:0,
			y:0,
			offsetY:-1,
			width:cssSettingsAvatars.avatarHeight,
			height:cssSettingsAvatars.avatarHeight,
			verticalAlign: 'middle',
			align:'center',
			fontFamily:cssSettingsAvatars.genericAvatar.fontFamily,
			text:textData,
			fill:textColor || cssSettingsAvatars.genericAvatar.fontColor,
			fontSize:cssSettingsAvatars.genericAvatar.fontSize,
			perfectDrawEnabled:true
		})
		avatarGroup.add(avatarRect)
		avatarGroup.add(avatarText)
		return {
			group:avatarGroup,
			rect:avatarRect,
			text:avatarText
		}
	}
	createAvatarsToolTip(avatarGroupData:IAvatarGroupData,textData:string,fontSize:number,backGround:string) {
		let tooltipData = this.knUIElementsService.createToolTip(avatarGroupData.rect,textData,fontSize,1,backGround,20)
		avatarGroupData.group.add(tooltipData.group)
		avatarGroupData.text.on('mouseover', () => {
			this.knUIElementsService.togglePointer('pointer');
			tooltipData.group.show()
		})
		avatarGroupData.text.on('mouseout', () => {
			this.knUIElementsService.togglePointer('default');
			tooltipData.group.hide()
		})
	}
	handleImgAvatars(avatarData:Map<string,{img:SafeUrl}>) {
        let bpLayer = this.knDataService.layersMap.get(BUSINESS_PROCESS_LAYER_ID)
		if (!bpLayer) {
			return
		}
		Array.from(avatarData).forEach(avatar=>{
            let userGuid = avatar[0]
			let groupId = '#avatarGroup_' + userGuid
			let avatarGroup = bpLayer.layer.find(groupId) as Group[]
			let imgUrl=this.sanitizer.sanitize(SecurityContext.URL,avatar[1].img)
			avatarGroup.forEach(group=>{
                let cssAvatar = group.attrs.css
				let tooltip = group.children.find(el=>el.attrs.id==='tooltipGroup') as Group
				Image.fromURL(imgUrl!, (image)=>{
					image.width(cssAvatar.avatarHeight)
					image.height(cssAvatar.avatarHeight)
					image.cornerRadius(cssAvatar.avatarRadius)
					image.stroke(cssAvatar.borderColor)
					image.strokeWidth(cssAvatar.borderSize)
					image.moveToTop()
					image.on('mouseover', () => {
						this.knUIElementsService.togglePointer('pointer');
						tooltip?.show()
					})
					image.on('mouseout', () => {
						this.knUIElementsService.togglePointer('default');
						tooltip?.hide()
					})
					image.on('click', (event) => {
						event.cancelBubble = true
						this.helpersService.openProfileByGuid(userGuid)
					})
					group.add(image);
				})

			})
		})
	}
	prepareGenericAvatarBackGround (email:string):IGradient {
      let randomNumber = crc1(email) % colorForGenAvatars.length;
      return { 
		startcolor: (colorForGenAvatars)[randomNumber][0],
		endColor: (colorForGenAvatars)[randomNumber][1]
		}
	}
	prepareUserList(node:IGraphNode):IGuidRole[] {
        let statusData = this.graphHelpersService.getStatusData(node)
        let userData:IGuidRole[] = [] 
            for (const key in statusData?.roles) {
                let guids =  (statusData?.roles as any)[key] as string[]
                if (guids?.length>0) {
                    let data:IGuidRole[]= guids.map(el=>{return {
                        guid:el,
                        role:key
                    }})
                    userData.push(...data)
                }
            } 
        return userData.flat()
	}
}